export enum FormType {
  Demande = 1, // Formulaire type Demande
  Sondage = 2 // Formulaire type Sondage
}

export enum FormState {
  draft = 1, // Formulaire en cours de construction
  published = 2, // Formulaire en ligne, les utilisateurs peuvent le remplir
  offline = 3, // Formulaire non disponible en ligne pour les utilisateurs
  archived = 4 // Formulaire archivés, n'est plus utilisable
}

export enum ReponseState {
  temp = 0, // Réponse temporaire
  draft = 1, // Réponse en cours de rédaction
  published = 2, // Réponse envoyé pour traitement
  archived = 3 // Réponse archivée
}

export enum ResponseStateInstruction {
  in_progress = 0, // en instruction / en traitement
  accepted = 1,
  refused = 2,
  closed = 3, // sans suite
  incomplete = 4 // demande incomplète
}
export enum FieldType {
  TypeLabel = 'label',
  TypeCheckbox = 'checkbox',
  TypeText = 'text',
  TypeTextarea = 'textarea',
  TypeDate = 'datepicker',
  TypeRadio = 'radio',
  TypePhone = 'phone',
  TypeEmail = 'email',
  TypeSelect = 'select',
  TypeFile = 'file',
  TypeSvcCmp = 'svc_cmp',
  TypeAvis = 'avis',
}
export enum BlockTypeEnum {
  Public = 1,
  Administratif = 2,
}

